import { Autocomplete, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function BigQueryTableSelector({
  datasetId,
  selectedTable = null,
  onSelectTable,
  showError = false,
  label = "Select table",
  title = null,
}) {
  BigQueryTableSelector.propTypes = {
    datasetId: PropTypes.string.isRequired,
    selectedTable: PropTypes.string,
    onSelectTable: PropTypes.func.isRequired,
    showError: PropTypes.bool,
    label: PropTypes.string,
    title: PropTypes.string,
  };

  const { projectId } = useParams();
  const [didUserTouchField, setDidUserTouchField] = useState(false);
  const [tablesOptions, setTablesOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const showFieldError = !selectedTable && (didUserTouchField || showError);

  useEffect(() => {
    const fetchTables = async () => {
      if (!datasetId) return;

      setIsLoading(true);
      try {
        const queryParams = new URLSearchParams();
        queryParams.set("project_id", projectId);
        queryParams.set("dataset_id", datasetId);
        const response = await fetch(`/bigquery/list-tables/?${queryParams.toString()}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setTablesOptions(data);
      } catch (error) {
        console.error("Error fetching tables:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTables();
  }, [projectId, datasetId]);

  return (
    <>
      {title && (
        <Typography variant="h4" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      <Autocomplete
        id="table-selector"
        value={selectedTable}
        disabled={!datasetId}
        onChange={onSelectTable}
        loading={isLoading}
        options={tablesOptions}
        noOptionsText={
          !datasetId ? "Select dataset first" :
          isLoading ? "Loading..." :
          `No tables found in \`${projectId}.${datasetId}\`.`
        }
        fullWidth={true}
        sx={{ mb: 1 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            disabled={!datasetId}
            error={showFieldError}
            onBlur={() => setDidUserTouchField(true)}
            helperText={
              showFieldError ? "Please select a table" : " "
            }
          />
        )}
      />
    </>
  );
}